import { render } from "./RegisterGridForm.vue?vue&type=template&id=4e907d8c"
import script from "./RegisterGridForm.vue?vue&type=script&lang=js"
export * from "./RegisterGridForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QResponsive from 'quasar/src/components/responsive/QResponsive.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QResponsive});
